   <div style="padding:16px 0;height:600px;overflow-x:hidden;">
                   <div class="container-fluid px-0">
                    <div class="row g-4 align-items-start mx-0" style="height:30;">
                        <div class="col-12 col-xl-2">
                                <button class="btn btn-primary mt-3 ace-blue" style="width:200px;position: relative;top:-10px;" (click)="onGeneratePreliminaryInvoice()" [disabled]="disablePrelimGeneration">
                                    Generate Prelims
                            </button>
                        </div>
                        <div class="col-12 col-xl-2">
                            <mat-form-field appearance="outline" style="width:100%;">
                                    <mat-label>Start Month</mat-label>
                                    <mat-select [(ngModel)]="selectedMonths" (selectionChange)="onStartMonthChange()">
                                        <mat-option [value]="''">Select Start Month</mat-option>
                                        @for (monthDate of pastMonthDateOptions; track monthDate.getTime(); let i = $index) {
                                            <mat-option [value]="i +1">{{ monthDate | date: 'M-d-yyyy' }}</mat-option>
                                        }
                                    </mat-select>
                                </mat-form-field>
                        </div>
                        <div class="col-12 col-xl-2">
                            <mat-form-field appearance="outline" style="width:100%;">
                                    <mat-label>End Month</mat-label>
                                    <input matInput readonly [value]="endMonth | date: 'M-d-yyyy'" />
                            </mat-form-field>
                            <div style="position:relative;margin-top:-10px;">
                                <span>Due Date: <strong>{{ dueDate | date: 'M-d-yyyy' }}</strong></span>
                            </div>
                        </div>
                        
                        <div class="col-12 col-xl-6">
                           @if(isInvoiceLineDescriptionCustomizationEnabled){
                                <mat-form-field appearance="outline" style="margin-left:0px; width:100%;">
                                            <mat-label>Invoice Line Description</mat-label>
                                            <input
                                                matInput
                                                [value]="invoiceLineDescription"
                                                maxlength="250"
                                                (input)="invoiceLineDescription = $any($event.target).value"
                                                style="width:95%;"
                                            />
                                </mat-form-field>
                            }
                        </div>
                    </div>
                    <div class="row g-4 align-items-start mx-0" style="margin-top:0px;">
                           
                            <div class="col-12 col-xl-6">
                                <span><strong>Companies Found ({{companyList.length}})</strong></span>
                                <mat-selection-list #companySelectionList class="no-selection-indicator company-highlight-list" [multiple]="true" hideSingleSelectionIndicator [ngModel]="selectedCompanyIds" (ngModelChange)="onCompanySelectionChange($event ?? [])" (mousedown)="onCompanyListPointerDown($event)" (keydown)="onCompanyListKeydown($event, companySelectionList)" style="width:100%;height:287px;overflow-y:auto;border:1px solid darkgray;">
                                    <!-- <mat-list-option class="ace-blue list-placeholder-row" [disabled]="true" [value]="''">--  --</mat-list-option> -->
                                    @for(company of companyList; track company.companyId) {
                                        <mat-list-option [value]="company.companyId">{{ company.companyName }}</mat-list-option>
                                    }
                                </mat-selection-list>
                                <div style="margin-top:10px;">
                                    <span>Control-Click to select multiple companies.  Control-A to select all.</span>
                                </div>
                            </div>
                            <div class="col-12 col-xl-6">
                                @if(companyMultiSelectModifierActive){
                                    <p>All unbilled Parkers will be submitted when multiple companies are selected</p>
                                }
                                @else{
                                    @if(parkerList.length > 0) {
                                        <span><strong>Parkers ({{parkerList.length}}) / Selected ({{parkerSelectionList.selectedOptions.selected.length}})</strong></span>
                                        <mat-selection-list #parkerSelectionList class="parker-highlight-list" [multiple]="true" [disabled]="isParkerSelectionReadOnly" style="width:100%;height:287px;overflow-y:auto;border:1px solid darkgray;">
                                            <!-- <mat-list-option class="ace-blue parker-list-placeholder list-placeholder-row" [disabled]="true" [value]="''">-- Parkers ({{parkerList.length}}) / Selected ({{parkerSelectionList.selectedOptions.selected.length}}) --</mat-list-option> -->
                                            @for(parker of parkerList; track parker.parkerId) {
                                                <mat-list-option togglePosition="before" [value]="parker.parkerId">
                                                    <span matListItemTitle style="display:flex;justify-content:space-between;gap:12px;width:100%;">
                                                        <span>{{ parker.lastName }}, {{ parker.firstName }}</span>
                                                        <span style="font-weight:normal;">{{ parker.parkerPayType }}</span>
                                                    </span>
                                                </mat-list-option>
                                            }
                                        </mat-selection-list>
                                        <div style="display:flex;gap:10px;margin-top:10px;align-items:center;">
                                            <mat-checkbox
                                                class="select-all-parkers-checkbox"
                                                [(ngModel)]="isSelectAllParkersChecked"
                                                [disabled]="isMultipleCompaniesSelected"
                                                (change)="onToggleSelectAllParkers(parkerSelectionList)"
                                            >
                                                Select all Parkers
                                            </mat-checkbox><span>(Only unbilled Parkers for selected billing periods will be included in the invoice generation.)</span>
                                        </div>
                                    }
                                    @else {
                                        <span><strong>Parkers Found ({{parkerList.length}})</strong></span>
                                        <div style="width:100%;height:287px;border:1px solid darkgray;display:flex;align-items:center;justify-content:center;font-size:16pt;font-weight:700;">
                                            @if(!currentSelectedCompanyId) {
                                                Please select a Company to view Parkers
                                            }
                                            @else {
                                                There are no parkers for this company
                                            }
                                        </div>
                                    }
                                }
                            </div>
                        </div>
                    </div>
                    </div>
                   
